module.exports = __webpack_public_path__ + "static/About Image 7-0dcab73336c38af0ebf45b0470ac6092.jpg";